import { render, staticRenderFns } from "./OnePhaseOneFile.vue?vue&type=template&id=734cbe51"
import script from "./OnePhaseOneFile.vue?vue&type=script&lang=js"
export * from "./OnePhaseOneFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports